import { useContext } from 'react';

import {
  LegalClientBeneficiaryEntity,
  LegalClientEntity,
  LegalClientRepresentativeEntity,
} from 'api/types/entity';
import {
  OnboardingContext,
  OnboardingContextProps,
} from 'modules/onboarding/common/providers/OnboardingProvider/Context';

export const useOnboardingContext = () => {
  const res = useContext(OnboardingContext);
  return res as OnboardingContextProps<{
    currentClient: LegalClientRepresentativeEntity;
    legalClient: LegalClientEntity;
    legalClientBeneficiary: LegalClientBeneficiaryEntity;
    onCreateBeneficiary: (id: string) => void;
  }>;
};
